<template>
  <GmapMarker
    :options="markerOptions"
    @click="!disabled ? $emit('click', healthcenter) : undefined"
  >
    <div class="relative flex items-center justify-center">
      <img
        alt="marker-icon"
        :src="isProductAvailable() ? Available : Unavailable"
        width="25"
        height="25"
      >
      <p class="absolute top-2 text-white font-bold">
        {{ productStock }}
      </p>
    </div>
  </GmapMarker>
</template>

<script setup lang="ts">
import {computed} from 'vue';
import {CustomMarker as GmapMarker} from "vue3-google-map";
import Available from '@/assets/images/map-markers/availabilities/available.svg';
import Unavailable from '@/assets/images/map-markers/availabilities/unavailable.svg';
import {HealthcenterGroupMember} from "@/disruption-logistics/interfaces/availability-providers";

const {healthcenter, disabled = false} = defineProps<{
    healthcenter: HealthcenterGroupMember,
    disabled?: boolean,
    isGrouping?: boolean
}>();
defineEmits(['click']);

/**
 * Get the healthcenter product stock.
 */
const productStock = computed((): number => {
    return healthcenter.stocks?.length ? healthcenter.stocks[0].quantity : 0;
});

const markerOptions = computed((): google.maps.CustomMarkerOptions => {
    return {
        position: {
            lat: healthcenter.address?.latitude || 0,
            lng: healthcenter.address?.longitude || 0
        },
        anchorPoint: 'CENTER',
    };
});

/**
 * Check if the product is available.
 */
const isProductAvailable = (): boolean => {
    return !!(healthcenter.stocks?.length && healthcenter.stocks[0].quantity > 0);
};
</script>
